<template>
  <div>
    <div class="title-bar">
      <div class="title-h4">기본 정보</div>
    </div>
    <el-form :model="alarmData" label-position="top" ref="alarmInfoForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="알람명" prop="eventName">
            <el-input v-model="alarmData.eventName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="알람 활성화" prop="applyFlag">
            <el-switch v-model="alarmData.applyFlag" active-value="Y" inactive-value="N"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="수신자 설정" prop="receiver">
          <el-table-wrapper :column-default="columnDefault" border :data="receiverData" :columns="receiverColumns" :pagination="false"
            :show-custom-header="false" header-align="center" highlight-current-row @selection-change="onSelectionChange" ref="receiverTable">
          </el-table-wrapper>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="알람 종류" prop="eventType">
          <el-select v-model="alarmData.eventType" @change="changeAlarmSetting" :disabled="!isAdd">
            <el-option
              v-for="item in alarmTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { isEmpty } from 'lodash';
import AlarmAPI from '@/api/settings/log/lms-alarm-setting';

export default {
  name: 'WAlarmInfoView',
  props: {
    alarmData: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
  },
  data() {
    const eventValidation = (rule, value, callback) => {
      if (isEmpty(value)) {
        return callback(new Error('필수 정보 입니다.'));
      }
      if (value.length > 250) {
        return callback(new Error('250자 이상은 입력할 수 없습니다.'));
      }
      return callback();
    };
    return {
      columnDefault,
      receiverData: [],
      rules: {
        eventName: [
          { required: true, validator: eventValidation, trigger: 'blur' },
        ],
      },
      receiverColumns: [
        {
          align: 'center',
          headerAlign: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        {
          label: '사용자 계정',
          prop: 'managerId',
        },
      ],
      alarmTypeList: [
        {
          label: '발생 횟수',
          value: 'KEYWORD_COUNT',
        },
        {
          label: '머신러닝 패턴',
          value: 'ML_PATTERN',
        },
        {
          label: '미확인 패턴',
          value: 'UNKNOWN_PATTERN',
        },
        {
          label: '베이스라인',
          value: 'BASELINE',
        },
        {
          label: '저장소',
          value: 'STORAGE',
        },
      ],
    };
  },
  methods: {
    /**
     * 알람 수신자 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadApplyReciverList() {
      const param = {
        alarmId: this.alarmData.eventId,
      };
      AlarmAPI.getApplyReciverList(param).then((response) => {
        if (response.data.success) {
          this.receiverData = response.data.data;
          this.$nextTick(() => {
            const originReceiverData = [];
            this.receiverData.forEach((item) => {
              if (item.applyFlag === 'Y') {
                originReceiverData.push(item);
                this.$refs.receiverTable.$children[0].toggleRowSelection(item);
              }
            });
            this.$emit('setOriginReceiver', originReceiverData);
          });
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수신자 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 알람 기본 설정 데이터 로드 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      if (this.isAdd) {
        AlarmAPI.getUserList().then((response) => {
          if (response.data.success) {
            this.receiverData = response.data.data;
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수신자 목록', false));
          throw new Error(e);
        });
      } else {
        this.loadApplyReciverList();
      }
    },
    /**
     * 다음 버튼 클릭 시 validation 체크
     * @author leesy918
     * @return {[type]} [description]
     */
    nextStep() {
      this.$refs.alarmInfoForm.validate().then((success) => {
        if (success) {
          this.$emit('increaseActiveStep');
        }
      }).catch(() => {});
    },
    /**
     * validation 초기화
     * @author leesy918
     */
    resetFields() {
      this.$refs.alarmInfoForm.resetFields();
    },
    /**
     * 알람 조건 변경 시 이벤트 목록 초기화
     * @author leesy918
     * @return {[type]} [description]
     */
    changeAlarmSetting() {
      this.eventlevelData = [];
      this.$emit('initAlarmData');
    },
    /**
     * 수신자 설정 함수
     * @author leesy918
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      this.alarmData.alarmReceiver = selection;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmInfoView.vue